import {useCallback,useEffect,useState} from 'react'
import {AlertTriangle,RefreshCcw,ShieldCheck} from 'lucide-react'
import {supabase} from '../lib/supabase'
type Table={id:string;number:number;status:string}
type Order={id:string;table_id:string|null;status:string;total:number;created_at:string}
type Payment={order_id:string;amount:number}
type Command={id:string;table_id:string;status:string}
type Alert={key:string;level:'warning'|'info';message:string}
const money=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'})
export function CashSafetyMonitor(){
 const [alerts,setAlerts]=useState<Alert[]>([])
 const [count,setCount]=useState(0)
 const [loading,setLoading]=useState(false)
 const [error,setError]=useState('')
 const [checkedAt,setCheckedAt]=useState('')
 const refresh=useCallback(async()=>{
  setLoading(true);setError('')
  try{
   const [tablesResult,ordersResult,commandsResult]=await Promise.all([
    supabase.from('dining_tables').select('id,number,status').limit(200),
    supabase.from('orders').select('id,table_id,status,total,created_at').not('status','in','(closed,cancelled)').order('created_at',{ascending:false}).limit(1001),
    supabase.from('table_commands').select('id,table_id,status').not('status','in','(closed,cancelled)').limit(1001)
   ])
   if(tablesResult.error)throw tablesResult.error
   if(ordersResult.error)throw ordersResult.error
   if(commandsResult.error)throw commandsResult.error
   const tables=(tablesResult.data||[]) as Table[]
   const orders=(ordersResult.data||[]) as Order[]
   const commands=(commandsResult.data||[]) as Command[]
   const messages:Alert[]=[]
   if(commands.length>1000)messages.push({key:'command-limit',level:'warning',message:'Mais de 1.000 comandas ativas: conferência de mesas incompleta.'})
   if(orders.length>1000)messages.push({key:'limit',level:'warning',message:'Mais de 1.000 pedidos ativos. Conferência incompleta; procure suporte antes de fechar o caixa.'})
   const tableOrders=new Map<string,Order[]>()
   for(const o of orders){if(o.table_id)tableOrders.set(o.table_id,[...(tableOrders.get(o.table_id)||[]),o])}
   const active=orders.slice(0,1000)
   const commandTableIds=new Set(commands.map(c=>c.table_id))
   const paid=new Map<string,number>()
   for(let i=0;i<active.length;i+=80){
    const ids=active.slice(i,i+80).map(o=>o.id)
    const p=await supabase.from('payments').select('order_id,amount').in('order_id',ids).limit(10000)
    if(p.error)throw p.error
    for(const payment of (p.data||[]) as Payment[])paid.set(payment.order_id,(paid.get(payment.order_id)||0)+Number(payment.amount))
   }
   for(const t of tables){
    if(t.status==='free'&&commandTableIds.has(t.id))messages.push({key:'free-command-'+t.id,level:'warning',message:'Mesa '+t.number+' livre com comanda ativa. Conferir antes de liberar.'})
    const linked=tableOrders.get(t.id)||[]
    if(t.status==='free'&&linked.length>0)messages.push({key:'free-'+t.id,level:'warning',message:'Mesa '+t.number+' está livre, mas possui '+linked.length+' pedido(s) ainda não encerrado(s).'})
    if(['occupied','preparing','bill_requested','awaiting_payment'].includes(t.status)&&linked.length===0&&!commandTableIds.has(t.id))messages.push({key:'empty-'+t.id,level:'warning',message:'Mesa '+t.number+' está ocupada/solicitada sem pedido ativo. Verifique comandas e reservas antes de liberar.'})
   }
   for(const o of active){
    const received=paid.get(o.id)||0
    if(received>Number(o.total)+0.01)messages.push({key:'over-'+o.id,level:'warning',message:'Pedido '+o.id.slice(0,8)+' registra recebimento '+money.format(received)+' acima do total '+money.format(Number(o.total))+'. Confira pagamentos parciais ou estornos.'})
   }
   setAlerts(messages);setCount(active.length);setCheckedAt(new Date().toLocaleString('pt-BR'))
  }catch(e){setError(e instanceof Error?e.message:'Não foi possível verificar dados.')}
  finally{setLoading(false)}
 },[])
 useEffect(()=>{void refresh()},[refresh])
 return <div className="panel" style={{padding:18,marginBottom:18,display:'grid',gap:12,borderLeft:'4px solid #a87521'}}>
  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:12,flexWrap:'wrap'}}><div><strong><ShieldCheck size={18} style={{verticalAlign:'middle'}}/> Proteção do caixa — diagnóstico</strong><small style={{display:'block'}}>Somente leitura · não fecha mesas, não mexe em pedidos ou pagamentos</small></div><button type="button" className="secondary-button" onClick={()=>void refresh()} disabled={loading}><RefreshCcw size={17}/>{loading?'Conferindo…':'Conferir agora'}</button></div>
  {checkedAt&&<small>Última conferência: {checkedAt} · {count} pedido(s) não encerrado(s) examinados</small>}
  {error&&<div className="form-error" role="alert">{error}</div>}
  {!loading&&!error&&alerts.length===0&&<p style={{margin:0}}>Nenhuma das divergências verificadas foi identificada. Isso não substitui a conciliação financeira completa.</p>}
  {alerts.map(a=><div key={a.key} style={{display:'flex',gap:8,alignItems:'flex-start',padding:9,background:'rgba(180,120,20,.1)',borderRadius:8}}><AlertTriangle size={18}/><span>{a.message}</span></div>)}
  <small>Os alertas não alteram dados. A verificação considera comandas ativas, mas não analisa estoque, NFC-e nem pagamentos de pedidos já encerrados.</small>
 </div>
}
